// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__312t3","additionalInfo":"AgreementModal_additionalInfo__2BUf0"};